module.exports = __webpack_public_path__ + "img/Magnuss41.52c3ee8b.jpg";